import exactianLogoWhite from './exactian-logo-white.svg';
import exactianLogoBlack from './exactian-logo-black.svg';
import exactianLogoWord from './logo-exactian_301x51px.png';

export const icons = {
    exactianLogoWhite,
    exactianLogoBlack,
    exactianLogoWord,
}